module.exports = __webpack_public_path__ + "media/images/swiss/confirmation/confirmation-image@2x-8d266ed271ace4b896994ecaba2764c9.png";